import React from 'react'
import { IntervalInputProps } from '../IntervalInputProps'

const ActiveToggler = ({ interval, setInterval }: IntervalInputProps) => {
  const checkboxSize = '22px'
  const handleToggle = () => {
    setInterval({ ...interval, isActive: !interval.isActive })
  }

  const handleCheckBoxKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      handleToggle()
    }
  }

  return (
    <div className="flex items-center justify-between w-24 mb-4">
      Activer:
      <input
        type="checkbox"
        id="toggle-isActive"
        checked={interval.isActive}
        onChange={handleToggle}
        style={{ width: checkboxSize, height: checkboxSize, zIndex: 10 }}
        onKeyDown={(e) => handleCheckBoxKeyDown(e)}
      />
    </div>
  )
}

export default ActiveToggler
